// extracted by mini-css-extract-plugin
export default {"container":"BreadcrumbsPath_container__tKTtQ","title":"BreadcrumbsPath_title__83DCh"};